import { render, staticRenderFns } from "./CaseSamples.vue?vue&type=template&id=587a46b0&scoped=true&"
import script from "./CaseSamples.vue?vue&type=script&lang=js&"
export * from "./CaseSamples.vue?vue&type=script&lang=js&"
import style0 from "./CaseSamples.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CaseSamples.vue?vue&type=style&index=1&id=587a46b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a46b0",
  null
  
)

export default component.exports